import { Component, OnInit } from '@angular/core';
import {NotificationsService, SimpleNotificationsComponent} from 'angular2-notifications';
import * as $ from 'jquery';
import { CommonService, AuthenticationService } from './services/index';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'app works!';
  
  // for notification
  public options = {
    timeOut: 5000,
    lastOnBottom: true,
    clickToClose: true,
    maxLength: 0,
    maxStack: 7,
    showProgressBar: true,
    pauseOnHover: true,
    preventDuplicates: false,
    preventLastDuplicates: 'visible',
    rtl: false,
    animate: 'scale',
    position: ['right', 'bottom']
  };

  constructor(
  ) { }

  onCreate(event) {
  }

  onDestroy(event) {
  }

  ngOnInit() {
    CommonService.loadTheme();
  }

}
